import { values } from 'lodash';

import { FileUploadFlow, UIFile } from 'src/slices/files';

import { State } from 'src/store';

/**
 * Files for a flat (single-bucket) upload flow. Excludes INTERVIEWER_EVENT, whose bucket is keyed
 * by event id (a map of file-maps) rather than a flat file-map; read that per event via the
 * attachment hooks/selectors in `src/slices/files` instead.
 */
export const getFilesByUploadFlow = (
  state: State,
  fileUploadFlow: Exclude<FileUploadFlow, FileUploadFlow.INTERVIEWER_EVENT>
): UIFile[] => {
  return values(state.fileUpload[fileUploadFlow]);
};
